import { useEffect } from "react";
import { logout } from "api/Accounts/AccountsAPI";

export default function Logout() {
  useEffect(() => {
    async function doLogout() {
      await logout();
      window.location.href = "/";
    }
    doLogout();
  }, []);

  return null; // blank page
}
